import { render, staticRenderFns } from "./seniorDismissalManagement.vue?vue&type=template&id=604cca6b"
import script from "./seniorDismissalManagement.vue?vue&type=script&lang=js"
export * from "./seniorDismissalManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('604cca6b')) {
      api.createRecord('604cca6b', component.options)
    } else {
      api.reload('604cca6b', component.options)
    }
    module.hot.accept("./seniorDismissalManagement.vue?vue&type=template&id=604cca6b", function () {
      api.rerender('604cca6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/com/seniorDismissalManagement.vue"
export default component.exports